exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mhd--rounded-container {\n  margin-top: 30px;\n  position: relative;\n  border-radius: 16px;\n  padding: 30px 20px 20px;\n  border: 2px solid #d7d7d7; }\n  .mhd--rounded-container .title {\n    padding: 0 5px;\n    font-size: 26px;\n    color: #717171;\n    margin-top: -40px;\n    background: #fff;\n    position: absolute; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Common/Structure/roundedContainer.scss
// module id = 1318
// module chunks = 1